import React, { useEffect, useState } from "react";
import LoginBackgroundNew from "../../assets/images/LoginBackgroundNew.png";
import HeaderLogoNew from "../../assets/images/HeaderLogoNew.svg";
import Logo from "../../assets/images/Logo.svg";
import {
  Backdrop,
  Button,
  FormFieldSet,
  InputFieldShadow,
  LogoLoader,
  showToast,
} from "../../components";
import LoginBg from "../../components/Backgrounds/LoginBg";
import { useDispatch, useSelector } from "react-redux";
import { loginStart, clearError } from "../../redux/slices/auth/authSlice";
import { getItem, setItem } from "../../utils/localStorageUtils";
import { vi } from "@faker-js/faker";
import CryptoJS from "crypto-js";
import { passwordUpdate } from "../../redux/slices/setting/settingApi";

const defaultFormat = {
  base: "",
  minLength: 8,
  maxLength: 20,
  hasUpperCase: true,
  hasLowerCase: true,
  hasSpecialChar: true,
  hasNumber: true,
  allowedSpecialChars: "&()#*$@",
};

function validatePassword(password, rules) {
  const errors = [];

  if (!password) {
    return { isValid: false, errors: ["Password is required"] };
  }

  // Length check
  if (password.length < rules.minLength) {
    errors.push(`Password must be at least ${rules.minLength} characters`);
  }

  if (password.length > rules.maxLength) {
    errors.push(`Password must not exceed ${rules.maxLength} characters`);
  }

  // Uppercase check
  if (rules.hasUpperCase && !/[A-Z]/.test(password)) {
    errors.push("Password must contain at least one uppercase letter");
  }

  // Lowercase check
  if (rules.hasLowerCase && !/[a-z]/.test(password)) {
    errors.push("Password must contain at least one lowercase letter");
  }

  // Number check
  if (rules.hasNumber && !/[0-9]/.test(password)) {
    errors.push("Password must contain at least one number");
  }

  // Special character check (ONLY allowed ones)
  if (rules.hasSpecialChar) {
    const specialRegex = new RegExp(
      `[${rules.allowedSpecialChars.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&")}]`
    );

    if (!specialRegex.test(password)) {
      errors.push(
        `Password must contain at least one special character (${rules.allowedSpecialChars})`
      );
    }

    // Block unallowed special characters
    const invalidSpecialRegex = new RegExp(
      `[^a-zA-Z0-9${rules.allowedSpecialChars.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&")}]`
    );

    if (invalidSpecialRegex.test(password)) {
      errors.push(
        `Password contains invalid special characters. Allowed: ${rules.allowedSpecialChars}`
      );
    }
  }

  return {
    isValid: errors.length === 0,
    errors,
  };
}

const SetPassword = ({ uiid }) => {
  const [decryptedUiid, setDecryptedUiid] = useState("");
  let mainUiid = ""

  const ENV = import.meta.env.VITE_APP_ENV || "local";
  const ENCRYPTION_KEY = import.meta.env.VITE_AES_KEY;
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false)
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [confirmPassword, setConfirmPassword] = useState();
  const [showPassword, setShowPassword] = useState(false);

  const handleCreatePassword = async () => {
    mainUiid = decryptedUiid;
    const navigateLink =
      ENV === "production"
        ? import.meta.env.VITE_PRODUCTION_FRONTEND_URL
        : ENV === "staging"
          ? import.meta.env.VITE_STAGING_FRONTEND_URL
          : import.meta.env.VITE_LOCAL_FRONTEND_URL;

    if (password != confirmPassword) {
      showToast("Passwords do not match.", "error", 2000);
      return;
    }

    const passwordRegex =
      /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[&()#*$@])[A-Za-z\d&()#*$@]+$/;

    if (!password) {
      showToast("Password is required!", "error", 2000);
      return;
    }

    if (password.length < 8) {
      showToast("Password must be at least 8 characters!", "error", 2000);
      return;
    }

    if (!passwordRegex.test(password)) {
      showToast(
        "Password must include uppercase, lowercase, number, and one special character (& ( ) # * $ @).",
        "error",
        4000,
      );
      return;
    }

    if (!decryptedUiid) {
      const localStorageUiid = getItem("uiid");
      mainUiid = localStorageUiid;
    }

    if (!mainUiid) {
      showToast("Something went wrong. Try again after some time", "error", 2000);
      return;
    }


    try {
      setLoading(true);
      const res = await passwordUpdate({
        id: mainUiid,
        password: password,
      });

      showToast(
        "Password Created",
        4000,
      );

      setTimeout(() => {
        window.location.replace(navigateLink);
      }, 0);


    } catch (error) {
      showToast(
        "Something went wrong.",
        "error",
        4000,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!uiid) return;

    try {
      const bytes = CryptoJS.AES.decrypt(uiid, ENCRYPTION_KEY);
      const decrypted = bytes.toString(CryptoJS.enc.Utf8);
      console.log(decrypted);
      setDecryptedUiid(decrypted)
    } catch (err) {
      console.error("Decryption failed:", err);
    }
  }, [uiid]);

  console.log(decryptedUiid);


  return (
    <div
      className="w-full min-h-screen bg-no-repeat bg-cover bg-center bg-fixed"
      style={{ backgroundImage: `url(${LoginBackgroundNew})` }}
    >
      <div className="xs:p-5 md:p-10 gap-10 min-h-screen flex flex-col flex-1">
        <div>
          <div className="select-none">
            <img src={HeaderLogoNew} alt="Kult Works" className="" />
          </div>
        </div>
        <div className="flex-1 flex items-center justify-between gap-10 xs:flex-col lg:flex-row text-white">
          <div className=" xs:hidden lg:flex flex-col gap-10">
            <h1 className="text-shadow font-semibold mb-3 xs:text-5xl sm:text-6xl md:text-[86px]">
              Welcome...
            </h1>
            <p className="xs:text-base md:text-[16px] leading-[24px] w-full max-w-[650px] font-light">
              Supercharge Your Recruitment with Next-Gen Technology.Unlock the
              power of AI-driven, all-in-one ATS designed to help staffing
              agencies recruit smarter, faster, and more efficiently.
            </p>
            <div className="xs:mt-4 lg:mt-4">
              <Button title={"Learn More"} size="xl" />
            </div>
          </div>
          <div className="flex-1 flex justify-end items-center ">
            <div className="w-full xs:min-w-[280px] sm:min-w-[420px] max-w-[560px]">
              <LoginBg className={"rounded-3xl w-full"}>
                {/* <div className="bg-dark"> */}
                <div className="w-full flex-1 flex flex-col items-center justify-between xs:px-4 sm:px-10  pt-16 pb-20">
                  <img
                    src={Logo}
                    alt="Kult Works Logo"
                    className="w-[60px] lg:w-[80px] h-[60px] lg:h-[80px]"
                  />
                  <div>
                    <h2 className="text-center text-white xs:text-3xl text-4xl font-semibold my-10 ">
                      Set Password
                    </h2>
                  </div>
                  <form
                    className="w-full max-w-80 flex flex-col gap-8"
                    onSubmit={(e) => {
                      e.preventDefault();
                    }}
                  >
                    <div className="relative">
                      <InputFieldShadow
                        label="Enter Password"
                        icon={
                          <span
                            onClick={() => setShowPassword(!showPassword)}
                            className="cursor-pointer"
                          >
                            {showPassword ? "visibility_off" : "visibility"}
                          </span>
                        }
                        type={showPassword ? "text" : "password"}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                      />
                    </div>

                    <InputFieldShadow
                      label="Confirm Password"
                      icon={
                        <span
                          onClick={() => setShowPassword(!showPassword)}
                          className="cursor-pointer"
                        >
                          {showPassword ? "visibility_off" : "visibility"}
                        </span>
                      }
                      type={showPassword ? "text" : "password"}
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                    />
                    <Button
                      title={loading ? "Creating..." : "Create Password"}
                      disabled={loading}
                      onClick={handleCreatePassword}
                    />
                  </form>
                </div>
                {/* </div> */}
              </LoginBg>
            </div>
          </div>
        </div>
      </div>

      <Backdrop isOpen={loading}>
        <LogoLoader />
      </Backdrop>
    </div>
  );
};

export default SetPassword;
